import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import { Tooltip } from '@mui/material';

const MetricBox = ({ title, value, infoText, changeValue, isTrendingUp }) => {
    return (
        <div
            style={{
                padding: '16px',
                backgroundColor: '#f4f4f4',
                borderRadius: '8px',
                flex: 1,
                border: '1px solid #ddd', // Outline
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                position: 'relative',
            }}
        >
            {/* Title and Info Button Row */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                }}
            >
                <h3
                    style={{
                        margin: 0,
                        fontSize: '14px',
                        fontWeight: '400', // Standard weight
                        color: '#888', // Lighter color
                    }}
                >
                    {title}
                </h3>
                <Tooltip title={infoText || 'No information available'}>
                    <InfoOutlinedIcon
                        sx={{
                            fontSize: '20px',
                            color: '#888',
                            cursor: 'pointer',
                        }}
                    />
                </Tooltip>
            </div>

            {/* Value Row */}
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <p
                    style={{
                        margin: 0,
                        fontSize: '28px', // Larger font size
                        fontWeight: '500', // Slightly reduced weight
                        color: '#2c3e50', // Primary color
                    }}
                >
                    {value}
                </p>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#e0e0e0',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        color: '#28a745',
                        //color: isTrendingUp ? '#28a745' : '#dc3545', // Green for up, red for down
                    }}
                >
                    {/* Trending Icon */}
                    {isTrendingUp ? (
                        <TrendingUpIcon sx={{ fontSize: '14px', marginRight: '4px' }} />
                    ) : (
                        <TrendingDownIcon sx={{ fontSize: '14px', marginRight: '4px' }} />
                    )}
                    {/* Change Text */}
                    {changeValue} over 30 days
                </div>
            </div>
        </div>
    );
};

export default MetricBox;